
import './App.css';

import Ui from './main/ui';
import React from 'react';



function App() {

  return (
    <>
    <Ui />
    </>
  )
}

export default App;
